import { FEATURES_TYPES } from "@/configs";
import { get } from "@/utils/helpers";
import { createSelector } from 'reselect';

export const getProfile = (state) => get(state, ['auth']);
export const getProfilePshId = (state) => get(state, ['auth', 'psychologist', 'id']);
export const getProfileNutritionistId = (state) => get(state, ['auth', 'nutritionist', 'id']);
export const hasPsychologistProfile = (state) => Boolean(get(state, ['auth', 'psychologist']));
export const hasNutritionistProfile = (state) => Boolean(get(state, ['auth', 'nutritionist']));
export const getSelfPsychologistProfile = (state) => get(state, ['specialistProfile', 'psychologist']);
export const getSelfNutritionistProfile = (state) => get(state, ['specialistProfile', 'nutritionist']);
export const isAdminSelector = (state) => {
  return get(state, ['auth', 'is_superuser']) && get(state, ['auth', 'is_staff']);
};
export const isPsychologistSeletor = (state) => {
  return get(state, ['auth', 'is_staff']) && !get(state, ['auth', 'is_superuser']);
};

export const getPsychologistsPageData = (state) => get(state, ['psychologists']);
export const getPsychologistProfilePageData = (state) => get(state, ['psychologist']);
export const getPsychologistProfile = (state) => get(state, ['psychologist', 'data']);
export const getPsychologistFeedbacks = (state) => get(state, ['psychologist', 'feedbacks', 'results']);
export const getPsychologistNews = (state) => get(state, ['psychologist', 'news', 'results']);

export const getConsultationsPageData = (state) => get(state, ['consultations']);
export const getConsultationPageData = (state) => get(state, ['consultation']);
export const getConsultationById = (state, consultationId) => {
  if (!consultationId) return;
  const { data } = getConsultationsPageData(state);
  const { results: items = [] } = data || {};
  const item = items.find((item) => item?.id === consultationId);
  return item;
};

export const getAgoraConsultation = (state) => get(state, ['agora']);


export const getUsersPageData = (state) => get(state, ['users']);
export const getUserPageData = (state) => get(state, ['user']);
export const getUser = (state) => get(state, ['user', 'data']);

export const getSchedulersData = (state) => get(state, ['schedulers', 'data']);

export const getCheckoutsPageData = (state) => get(state, ['checkouts']);
export const getCallbacksPageData = (state) => get(state, ['callbacks']);
export const getFeedbacksPageData = (state) => get(state, ['feedbacks']);

export const getPagesPageData = (state) => get(state, ['pages']);
export const getSinglePageData = (state) => get(state, ['singlePage']);

export const getTasksPageData = (state) => get(state, ['tasks']);
export const getTasks = (state) => get(state, ['tasks', 'data']);
export const getTask = (state, taskId) => {
  const items = getTasks(state);
  const item = items.find(item => item?.id === taskId)
  return item;
}

export const getNotesPageData = (state) => get(state, ['notes']);

export const getProblemsPageData = (state) => get(state, ['problems']);
export const getProblems = (state) => get(state, ['problems', 'data']);
export const getProblemsOptions = createSelector(getProblems, (items) => {
  if (!items) return;
  return items.map((item) => ({ label: item?.name, value: item?.id }));
});

export const getCentersPageData = (state) => get(state, ['centers']);
export const getCenters = (state) => {
  const ids = get(state, ['centers', 'centers', 'allIds']);
  return ids?.map(id => get(state, ['centers', 'centers', 'byId', id]));
};
export const getCentersOptions = createSelector(getCenters, (items) => {
  if (!items) return;
  return items.map((item) => ({ label: item?.address, value: item?.id }));
});
export const getCenterServiceById = (state, serviceId) =>
  get(state, ['centers', 'services', serviceId]);
export const getCenterServiceDescriptionById = (state, id) =>
  get(state, ['centers', 'servicesDescriptions', id]);
export const getCenterById = (state, id) =>
  get(state, ['centers', 'centers', 'byId', id]);

export const getPrices = (state) => get(state, ['prices', 'data']);
export const getPricesLoaded = (state) => get(state, ['prices', 'isLoaded']);

export const getPromosPageData = (state) => get(state, ['promos']);
export const getPromos = (state) => get(state, ['promos', 'data']);

export const getFiltersPageData = (state) => get(state, ['filters']);
export const getFilters = (state) => get(state, ['filters', 'data']);
export const getFiltersOptions = createSelector(getFilters, (items) => {
  if (!items) return;
  return items.map((item) => ({ label: item?.text, value: item?.id }));
});

export const getUserCheckoutsHistory = (state) => get(state, ['userCheckoutsHistory', 'data']);

export const getSeoPagesPageData = (state) => get(state, ['seo']);
export const getSingleSeoPageData = (state) => get(state, ['singleSeoPage']);

export const getFeaturesPageData = (state) => get(state, ['features']);
export const getFeatures = (state) => get(state, ['features', 'data']);
export const getFeaturesLanguageOptions = createSelector(getFeatures, (items) => {
  if (!items) return
  return items?.filter((item) => item.type === FEATURES_TYPES.Language)?.map(item => ({ ...item, label: item?.name, value: item?.id }));
});
export const getFeaturesTagOptions = createSelector(getFeatures, (items) => {
  if (!items) return
  return items?.filter((item) => item.type === FEATURES_TYPES.Tag)?.map(item => ({ ...item, label: item?.name, value: item?.id }));
});

export const getBannersPageData = (state) => get(state, ['banners']);
export const getBanners = (state) => get(state, ['banners', 'data']);

export const getNutritionistsPageData = (state) => get(state, ['nutrition', 'nutritionists']);
export const getNutritionistPageData = (state) => get(state, ['nutrition', 'nutritionist']);
export const getNutritionConsultationsPageData = (state) => get(state, ['nutrition', 'consultations']);
export const getNutritionConsultationPageData = (state) => get(state, ['nutrition', 'consultation']);
export const getNutritionTasksPageData = (state) => get(state, ['nutrition', 'tasks']);
export const getNutritionNotesPageData = (state) => get(state, ['nutrition', 'notes']);
export const getNutritionFeedbacksPageData = (state) => get(state, ['nutrition', 'feedbacks']);
export const getNutritionFiltersPageData = (state) => get(state, ['nutrition', 'filters']);
export const getNutritionFeaturesPageData = (state) => get(state, ['nutrition', 'features']);
export const getNutritionAgora = (state) => get(state, ['nutrition', 'agora']);
